import { BaseService } from "./BaseService";
import {
  CopyHotelRequestDto,
  CopyHotelResultDto,
  CopyTenantRequestDto,
  CopyTenantResultDto,
} from "@/types/system-copy";

class SystemCopyService extends BaseService {
  private readonly basePath = "/admin/system-copy";

  constructor() {
    super();
  }

  copyTenant(dto: CopyTenantRequestDto): Promise<CopyTenantResultDto> {
    return this.post<CopyTenantResultDto>(`${this.basePath}/tenant`, dto);
  }

  copyHotel(dto: CopyHotelRequestDto): Promise<CopyHotelResultDto> {
    return this.post<CopyHotelResultDto>(`${this.basePath}/hotel`, dto);
  }
}

export const systemCopyService = new SystemCopyService();
